import {Injectable} from '@angular/core';
import {AbstractModelService} from '../model/abstract-model.service';
import {ApiClientService} from '../api-client/api-client.service';
import {AsyncCommand} from '../../models/async-command';
import {Observable} from 'rxjs';
import {ApiResponse} from '../../api/api-response';
import {RunnableCommand} from '../../models/runnable-command';

@Injectable({
  providedIn: 'root'
})
export class AsyncCommandService extends AbstractModelService<AsyncCommand> {

  constructor(apiClient: ApiClientService) {
    super(apiClient, '/async-command', AsyncCommand);
  }

  /**
   * Get runnable commands.
   */
  getRunnableCommands() {
    return new Observable<RunnableCommand[]>((subscriber) => {
      this.apiClient.get(this.routePath + '/list').subscribe({
        next: (response: ApiResponse) => {
          subscriber.next(response.getData().map((model: any) => new RunnableCommand().deserialize(model)));
          subscriber.complete();
        },
        error: (error) => {
          subscriber.error(error);
          subscriber.complete();
        }
      });
    });
  }

  run(runnableCommand: RunnableCommand) {
    return new Observable<AsyncCommand>((subscriber) => {
      this.apiClient.post(this.routePath + '/run', {}, {'id': runnableCommand.id}).subscribe({
        next: (response: ApiResponse) => {
          subscriber.next(new this._createClass().deserialize(response.getData()));
          subscriber.complete();
        },
        error: (error) => {
          subscriber.error(error);
          subscriber.complete();
        }
      });
    });
  }
}
